import React from 'react';
import PropTypes from 'prop-types';
import { reduce, get, map, size, filter, includes, has, isEmpty, forEach, head, keyBy } from 'lodash';
import styled, { css } from 'styled-components';
import { Form } from 'formik';
import * as Yup from 'yup';
import { Loading, Button, Icon, Row, Text, If, FlexContainer, HasPermissions, Accordion } from '../../common';
import UIStatusTable from '../../sections/Resume/UIStatusTable';
import { Query } from '../../graphql';
import OrderItemsDetailTab from '../../sections/Orders/OrderItemsDetailTabs';
import GetOrderItems from '../../graphql/getOrderItems';
import UpdateAuditOrder from '../../graphql/updateAuditOrder';
import { OrderAuditManagementConsumer } from '../../firebase/OrderAuditManagement';
import OrderCallHistory from '../../sections/OrderCallHistory';
import AuditHeaderInfo from './AuditHeaderInfo';
import { getColumns } from './AuditOrderTable';
import { withFirebase, withReloadable } from '../../../hoc';
import WeightValidation from './WeightValidation';
import { formatRefId } from '../../../utils/misc';
import GET_STOCK_BY_STORE_SKU from '../../../queries/GET_STOCK_BY_STORE_SKU';
const { excessColumns, substituteColumns, parentColumns } = getColumns();

const FooterWrapper = styled(Row)`
    position: ${({ position }) => position};
    bottom: 0;
    width: 100%;
    left: 0;
    padding: 15px;
    border-top: 1px solid #eaeaea;
    background-color: #ffffff;
    ${({ withZindex }) => withZindex && css`
        z-index: 2000;
    `}
`;

const IconContainer = styled.div`
    width: 90px;
    height: 90px;
    background-color: #f38630;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
`;
class AuditOrder extends React.Component {
    state = {
        currentStep: 0,
        formValues: {},
        wasSubmitted: {},
        loading: false,
        auditInProcess: false,
        auditValues: {},
        weightValidation: false,
        firebase: {},
        pickingResultAllowed: false,
        callAndChatHistoryAllowed: false
    };

    _renderTableItem = ({ auditInfo, ...ctx }, columns, onChangeValue) => (item, index) => {
        const { orderId, auditData } = this.props;
        const status = get(item, 'picking.status');

        const changeItemAuditValue = ({ name, value }) => {
            const { auditValues } = this.state;

            if (get(auditValues[name], 'value', 1) !== get(value, 'value', 1)) {
                // console.log('onchange before', auditValues, value)
                auditValues[name] = value;
                // console.log('onchange after', auditValues)
                this.setState({ auditValues });
            }
        };

        const parentProps = { orderId, storeId: get(auditData, 'idStore', null), auditInfo, onChangeValue: changeItemAuditValue, stockMap: get(columns, 'stockMap', {}), ...ctx }; // used to pass parent to atributes to children
        const hasExcess = has(item, 'picking.excess') && get(item, 'picking.excess') !== 0;
        // creates a children array from every substitution entry
        const children = map(get(item, 'picking.substitution', []), (childrenItem) => {
            return {
                ...childrenItem,
                picking: { status: String(status).toLowerCase() },
                type: String(status).toLowerCase()
            };
        });

        const hasChildren = size(children);

        const _drawRowBorderBottom = (has, index, siz) => {
            if ((index === siz) && (has === false)) return '1px solid #eaeaea';
            if (has === 0) return '1px solid #eaeaea';
            if (has) return '1px dashed #eaeaea';
            return '1px solid transparent';
        };

        const buildRow = (tds, { width, ...item }, index, prefix = 'item', hasChildren, style = {}, childStyle = {}) => {
            const id = String(get(item, 'picking.productId', `${prefix}-${index}`));
            const excessStyle = prefix === 'excess' ? { borderBottomLeftRadius: 8, borderBottomRightRadius: 8, boxShadow: '0px 2px 4px 0px #00000026' } : {};
            const parentStyle = prefix === 'parent' ? { borderTopLeftRadius: 8, borderTopRightRadius: 8 } : {};

            return (<>
                {prefix === 'parent' && <tr colSpan='12' style={{ height: 8, backgroundColor: '#f4f4f4' }}></tr>}
                <tr key={`${prefix}-item-${id}`} className='test' style={{ ...style, backgroundColor: 'white', ...excessStyle, ...parentStyle }}>
                    {tds.map(({ dataIndex, columnStyle, render = () => (null) }, key) => {
                        return <td key={`${prefix}-item-${id}-child-${key}`}
                            style={{
                                borderBottom: _drawRowBorderBottom(hasChildren, index + 1, size(children)),
                                padding: 10,
                                fontSize: '11px',
                                maxWidth: '210px',
                                textAlign: [8, 9, 10, 11].includes(key) ? 'right' : 'left',
                                ...columnStyle,
                                ...childStyle
                            }}
                        >
                            {render({ ...item }, dataIndex, parentProps)}
                        </td>;
                    })}
                    {size(tds) === 11 && <td></td>}
                </tr>
            </>);
        };

        const row = [item].map((item, index) => buildRow(get(columns, 'parentColumns', []), item, index, 'parent', hasChildren));

        const tableChunk = [
            ...row,
            hasChildren ? children.map((item, index) => buildRow(get(columns, 'subsColumns', []), item, index, 'children', false)) : [],
            hasExcess ? buildRow(get(columns, 'excessColumns', []), item, index, 'excess', false, { backgroundColor: ' #f4f4f4' }, { padding: '3px 10px' }) : []
        ];

        return tableChunk;
    }

  _renderTableHeader = ({ title, width }, key) => (
      <th
          className=''
          key={`th-${key}`}
          style={{
              width,
              fontSize: '12px',
              textAlign: includes(['Producto', 'Resultado picking', 'Estado', 'Regla', 'Validación', 'Stock Disponible'], title) ? 'left' : 'right',
              verticalAlign: 'top',
              backgroundColor: '#E2E2E2',
              boxShadow: '0px -1px 0px 0px #00000033 inset'
          }}
        >
          { title }
      </th>
  )

  _getHeaderLabels = (columns) => columns.map(({ title, width }) => ({ title, width }))

    _filterItems = (response) => {
        const { items, auditInfo, pickingTime } = response;
        const audits = filter(get(pickingTime, 'stats'), ['field', 'audit']);
        const invalidItems = map(get(auditInfo, 'results.failed'), ({ productId }) => productId);

        return filter(items, (orderItem) => {
            return includes(invalidItems, get(orderItem, 'picking.id')) || includes(['ADDED_BY_CLIENT'], get(orderItem, 'status'));
        });
    }

  _formGetInitialValues = (items) => {
      const { formValues } = this.state;
      return reduce(items, (acc, item) => {
          const productId = get(item, 'picking.productId');
          if (!productId) return acc;
          return Object.assign(acc, { [productId]: get(formValues, productId) });
      }, {});
  }

  _formGenerateValidationSchema = (fields) => {
      const items = filter(fields, ({ status }) => !includes(['ADDED_BY_CLIENT'], status));
      const _schema = reduce(items, (acc, item) => {
          const productId = get(item, 'picking.productId');
          return Object.assign(acc, {
              [productId]: Yup.object().shape({
                  value: Yup.string().required()
              })
          });
      }, {});
      return Yup.object().shape(_schema);
  }

  /*   changeItemAuditValue ({ name, value }, data = []) {
      const { initialValues } = this.state;
      if (isEmpty(initialValues)) {
        let initialize = {};
        forEach(this._filterItems(data), item => {
            const productId = get(item, 'picking.productId');
            if (productId) {
                initialize = { ...initialize, [productId]: { label: 'Aprobar', value: 1 } }
            }
        })
        console.log(initialize)
        this.setState({ initialValues: initialize });
      }
  } */

  assignProductIdValueResolver = (productId) => {
    const { auditValues } = this.state;
    const value = filter(auditValues, (_, index) => index === productId);
    return !isEmpty(value) ? head(value) : { label: 'Aprobar', value: 1 };
  }

  _formOnSubmit = (data) => {
      let values = {};
      forEach(data, item => {
          const productId = get(item, 'picking.productId', get(item, 'productId'));
          if (productId) {
              values = { ...values, [productId]: this.assignProductIdValueResolver(productId) };
          }
      });
      this.setState({ auditValues: {} });
      const validationResults = reduce(values, ({ approved, rejected }, { value }, key) =>
          ({ approved: value ? [...approved, { [key]: value }] : approved,
              rejected: !value ? [...rejected, { [key]: value }] : rejected
          }), { approved: [], rejected: [] });

      const submittedValues = reduce(values, (acc, { value }, key) => (Object.assign(acc, { [key]: value })), {});
      const hasntRejecteds = !size(get(validationResults, 'rejected'));

      // console.log(submittedValues);
      this.setState({
          wasSubmitted: true,
          formValues: submittedValues,
          validationResults,
          currentStep: hasntRejecteds ? 0 : this.state.currentStep + 1
      }, () => {
          if (hasntRejecteds) return this._performAudit();
      });
  }

  _formOnReset = () => {
      const { onAuditSuccess } = this.props;
      console.log('should reset values');
      onAuditSuccess();
  }

  _performAudit () {
      const { formValues } = this.state;
      const { orderId, userId, audit, onAuditSuccess, auditData } = this.props;
      const { performAudit } = audit;
      const audits = map(formValues, (value, key) => ({
          productEan: (key).split('-')[0],
          itemResponse: value === 1,
          userId,
          orderId
      }));
      const salesChannel =
          get(auditData, 'salesChannel.id') || get(auditData, 'salesChannel') || null;
      const payload = { userId, orderId, audits, salesChannel };
      this.setState({ auditInProcess: true });
      performAudit({ variables: payload }).then(() => {
          this.setState({ auditInProcess: false }, () => onAuditSuccess());
      });
  }

  // screen components

    _getStepsHeader () {
        const { currentStep } = this.state;
        return (
            <FlexContainer style={{ minHeight: '40px' }} align='center'>
                <Text text='Validación de productos' size={15} strong={currentStep === 0} paddingVertical={15} />
            </FlexContainer>
        );
    }

  async componentWillUnmount () {
      const { audit } = this.props;
      const { toggleAudit } = audit;
      await toggleAudit(false);
  }

    async componentDidMount () {
        const { audit } = this.props;
        const { toggleAudit } = audit;
        const { firebase } = this.props;

        await toggleAudit(true);

        await firebase.collection('salesChannel').doc(this.props.auditData.salesChannel.id).onSnapshot(doc => {
            this.setState({
                callAndChatHistoryAllowed: get(doc.data(), 'callAndChatHistory', false),
                pickingResultAllowed: get(doc.data(), 'pickingResult', false)
            });
        });
    }

    render () {
        const { orderId, withPicking } = this.props;
        const { currentStep, validationResults, auditInProcess, weightValidation } = this.state;
        return (
            <GetOrderItems
                variables={{ id: orderId }}
                fetchPolicy='network-only'
                withPicking={withPicking}
            >
                {({ data, loading }) => {
                    const firstAudit = !(size(filter(get(data, 'pickingTime.stats'), ['field', 'audit'])) > 1);
                    const weightError = get(data, 'weightError', 'null');
                    const semaphore = get(data, 'semaphore', null);
                    const storeId = get(this.props.auditData, 'idStore', null);
                    const filteredItems = this._filterItems(data);
                    const refIds = map(filteredItems, (item) => formatRefId(get(item, 'refId', ''))) || [];

                    return (
                        <FlexContainer direction='column' flex={1}>
                            <Loading loading={loading}>
                                <If condition={currentStep === 0} then={(
                                    <FlexContainer direction='column' width='100%' display='block' >
                                        <FlexContainer pT={20}>
                                            <AuditHeaderInfo orderId={orderId} dataParent={data} />
                                        </FlexContainer>
                                        {this.state.callAndChatHistoryAllowed &&
                                            <Accordion
                                                title={<Row align='center' gap={15}>
                                                    <Icon name='phone-rigning' color='#1FA02E' size={16} />
                                                    <Text strong text='Historial de Llamadas y Chat' />
                                                </Row>}
                                                iconOpened='chebron_down'
                                                iconClosed='chebron_up'
                                                iconSize={10}
                                                styleHeader={{ borderRadius: 8 }}
                                                background='#f4f4f4'
                                                closedBackground='white'
                                                style={{ boxShadow: '0px 4px 12px 0px #00000014', margin: '15px 0px 15px 0px', borderRadius: 8 }}
                                            >
                                                <OrderCallHistory
                                                    callHistoryType='shopper_calls'
                                                    orderId={orderId}
                                                    firebase={this.props.firebase}
                                                    isWhatsapp={get(data, 'isWhatsapp', false)}
                                                />
                                            </Accordion>
                                        }
                                        {this.state.pickingResultAllowed &&
                                            <Accordion
                                                title={<Row align='center' gap={15}>
                                                    <Icon name='cart' color='#1FA02E' size={16} />
                                                    <Text strong text='Resultado de picking' />
                                                </Row>}
                                                iconOpened='chebron_down'
                                                iconClosed='chebron_up'
                                                iconSize={10}
                                                styleHeader={{ borderRadius: 8 }}
                                                background='white'
                                                closedBackground='white'
                                                style={{ boxShadow: '0px 4px 12px 0px #00000014', margin: '0px 0px 15px 0px', borderRadius: 8 }}
                                            >
                                                <OrderItemsDetailTab
                                                    skipQuery
                                                    orderId={orderId}
                                                    dataFromParent={data}
                                                    withPicking
                                                />
                                            </Accordion>
                                        }
                                        
                                        <Form>
                                            <FlexContainer direction='column' flex={1}>
                                                <FlexContainer direction='column' grow={1} mB={100}>
                                                    <If
                                                        condition={firstAudit}
                                                        then={
                                                            <WeightValidation
                                                                weightError={weightError}
                                                                semaphore={semaphore}
                                                                callback={() => this.setState(({ weightValidation }) => ({ weightValidation: !weightValidation }))}
                                                            />
                                                        }
                                                    />
                                                    {this._getStepsHeader()}
                                                    {size(refIds) > 0 && (
                                                        <Query
                                                            query={GET_STOCK_BY_STORE_SKU}
                                                            variables={{ storeId, refIds }}
                                                        >
                                                            {({ data: stockData }) => {
                                                                const stockMap = keyBy(get(stockData, 'getStockByStoreAndSKU.data', []), (item) => formatRefId(get(item, 'matnr', '')));
                                                                return (
                                                                    <UIStatusTable
                                                                        className='default-table'
                                                                        tableProps={{ className: 'order-items-table' }}
                                                                        renderItem={this._renderTableItem(data, {
                                                                            parentColumns: parentColumns,
                                                                            subsColumns: substituteColumns,
                                                                            excessColumns,
                                                                            stockMap
                                                                        })}
                                                                        renderHeader={this._renderTableHeader}
                                                                        headers={this._getHeaderLabels(parentColumns)}
                                                                        data={filteredItems}
                                                                    />
                                                                );
                                                            }}
                                                        </Query>
                                                    )}

                                                </FlexContainer>
                                                <FooterWrapper
                                                    noWrap
                                                    noFlex
                                                    justify='flex-end'
                                                    position='absolute'
                                                >
                                                    <Button onClick={() => this._formOnReset()} secondary text='Cancelar' right={10} width={107} />
                                                    <HasPermissions to={['audit-monitor:perform-audit']}>
                                                        <Button
                                                            onClick={() => this._formOnSubmit(this._filterItems(data))}
                                                            disabled={auditInProcess || (firstAudit && !weightValidation && (weightError === 'true'))}
                                                            loading={auditInProcess}
                                                            text='Siguiente'
                                                            width={107}
                                                        />
                                                    </HasPermissions>
                                                </FooterWrapper>
                                            </FlexContainer>
                                        </Form>
                                    </FlexContainer>
                                )} />
                                <If condition={currentStep === 1 && size(get(validationResults, 'rejected'))}
                                    then={(
                                        <FlexContainer align='center' direction='column' justify='center' flex={1} >
                                            <IconContainer>
                                                <Icon name='exclamation' color='#ffffff' size={46.8} />
                                            </IconContainer>
                                            <FlexContainer mT={30} mB={100} direction='column' align='center'>
                                                <Row justify='center'>
                                                    <Text text='Se rechazaron &nbsp;' />
                                                    <Text strong text={`${size(get(validationResults, 'rejected'))} productos`} />
                                                </Row>
                                                <Row>
                                                    <Text centered text='Enviaremos esta información al shopper para corregir' />
                                                </Row>
                                            </FlexContainer>
                                            <FooterWrapper
                                                noWrap
                                                noFlex
                                            >
                                                <Button link text='btn.action.cancel' style={{ width: 110 }} onClick={() => this.setState({ currentStep: 0 })} />
                                                <Button
                                                    width={107}
                                                    disabled={auditInProcess}
                                                    loading={auditInProcess}
                                                    text='btn.action.confirm'
                                                    style={{ width: 110 }}
                                                    onClick={() => this._performAudit()}
                                                    />
                                            </FooterWrapper>
                                        </FlexContainer>
                                    )}
                                />
                            </Loading>
                        </FlexContainer>
                    );
                }}
            </GetOrderItems>
      );
  }
}

AuditOrder.propTypes = {
    audit: PropTypes.object,
    auditData: PropTypes.object,
    orderId: PropTypes.string,
    userId: PropTypes.string,
    onAuditSuccess: PropTypes.func,
    withPicking: PropTypes.bool,
    firebase: PropTypes.object
};

AuditOrder.defaultProps = {
    onAuditSuccess: () => (null)
};

export default withReloadable(withFirebase((props) => (
    <OrderAuditManagementConsumer orderId={get(props, 'orderId')}>
        {({ taken, toggleAudit }) => (
            <UpdateAuditOrder {...props}>
                {({ updateFn: performAudit, loading }) => (
                    <AuditOrder {...props} audit={{ performAudit, loading, toggleAudit, taken }} />
                )}
            </UpdateAuditOrder>
        )}
    </OrderAuditManagementConsumer>
), ['orderId']));
